import { isAnyOf } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { AppStartListening } from '@/app/appMiddleware';
import { RootState } from '@/app/appStore';
import { collectionApi } from '@/shared/api';
import { transformFrameIntoImage } from './helpers';
import { updateFramePoint, deletePoint, syncFrame } from './slice';

export const addCollectionListener = (startListening: AppStartListening) => {
  startListening({
    matcher: isAnyOf(updateFramePoint, deletePoint),
    effect: async (_, listenerApi) => {
      const state = listenerApi.getState() as RootState;

      const currentFrame =
        state.collection.framesList[state.collection.selectedFrameIndex];

      if (!state.collection.collectionId) return;

      if (!currentFrame.id) {
        toast.error('Frame image is not synced');
        return;
      }

      const newImage = transformFrameIntoImage(
        state.collection.collectionId,
        currentFrame,
        {
          ...state.canvas.dimensions,
          videoWidth: state.collection.imageSize.width,
          videoHeight: state.collection.imageSize.height,
        }
      );

      await listenerApi
        .dispatch(
          collectionApi.endpoints.deleteImage.initiate({
            collection_id: state.collection.collectionId,
            image_id: currentFrame.id,
          })
        )
        .unwrap();
      const newFrame = await listenerApi
        .dispatch(collectionApi.endpoints.createImage.initiate(newImage))
        .unwrap();

      listenerApi.dispatch(syncFrame(newFrame.result));
    },
  });
};
